// extracted by mini-css-extract-plugin
export default {"container":"CourseCalculator_container__PFY-u","gradeburger":"CourseCalculator_gradeburger__TDiuM"};